/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var CheckCircle = createReactComponent("check-circle", "CheckCircle", [["path", { "d": "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0", "key": "svg-0" }], ["path", { "d": "m8.667 12.633 1.505 1.721a1 1 0 0 0 1.564-.073L15.333 9.3", "key": "svg-1" }]]);

export { CheckCircle as default };
//# sourceMappingURL=CheckCircle.js.map
